import useTrans from "@/hooks/useTrans";
import { HomeOutlined } from "@ant-design/icons";
import { Breadcrumb } from "antd";
import Schema from "../Schema";

export default function BreadcrumbComponent ({title, url = '', isHeader = false}) {

    const trans = useTrans();
    const dataSchema = {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "Trang chủ",
            "item": "https://hanagold.vn"
          },
          {
            "@type": "ListItem",
            "position": 2,
            "name": title,
            "item": `https://hanagold.vn/${url}`
          }
        ]
    };

    return (
        <>
            <Schema post={dataSchema}/>
            <Breadcrumb className='bread_crumb_container' separator='none'>
                <Breadcrumb.Item href='/'>
                <HomeOutlined />
                <span>{trans?.breadcrumb_home}</span>
                </Breadcrumb.Item>
                <Breadcrumb.Item href={null}>
                    <span >
                        <span className='separator'>/</span>
                        { isHeader ? (
                            <h1 className='breadcrumb-h1'>
                            <span className='breadcrumb_title'>{title}</span>
                            </h1>
                        ) : (
                            <span className='breadcrumb_title'>{title}</span>
                        ) }
                        
                    </span>
                </Breadcrumb.Item>
            </Breadcrumb>
        </>
    );
}